import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LandCategoriesDt from '@/services/dataTransferModules/landCategoriesDt'

export default function useLandCategories(params = {}) {
	const landCategoriesDt = new LandCategoriesDt()

	const { t: $t } = useI18n()

	const defaults = {
		fieldsCreating: {
			name: '',
		},
		fieldsToPatch: [
			'name',
		],
	}

	const {
		loadEntityFlags: flags,

		entities: landCategories,
		getEntities: getLandCategories,

		createEntity: createLandCategory,

		entity: landCategory,
		getEntity: getLandCategory,

		entityPopup: landCategoryPopup,
		getEntityPopup: getLandCategoryPopup,

		entityPreview: landCategoryPreview,
		getEntityPreview: getLandCategoryPreview,

		patchEntity: patchLandCategory,
		updateEntity: putLandCategory,

		deleteEntity: deleteLandCategory,
	} = useBlProviders(
		landCategoriesDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error when loading categories of land plots'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error when creating a land plot category'),

				showErrorNotificationForLoadingOneEntity: true,
				errorNotificationTextForLoadingOneEntity: $t('Error loading land category category'),

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error when editing land category'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error when deleting a land plot category'),
			},
			params,
		),
	)

	return {
		flags,
		landCategories,
		landCategory,
		landCategoryPreview,
		landCategoryPopup,
		defaults,

		getLandCategories,
		getLandCategory,
		getLandCategoryPreview,
		getLandCategoryPopup,
		createLandCategory,
		putLandCategory,
		patchLandCategory,
		deleteLandCategory,
	}
}
